// hooks/useAuth.ts
import { useState, useEffect } from 'react';
import { getUser, isAuthenticated, logout, initAuth, getCurrentUser } from '../lib/auth';

export function useAuth() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const userData = await initAuth();
      if (userData) {
        setUser(userData);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
      setLoading(false);
    };
    init();
  }, []);

  const handleLogin = (userData: any) => {
    setUser(userData);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    logout();
    setUser(null);
    setIsLoggedIn(false);
  };

  const refreshUser = async () => {
    const userData = await getCurrentUser();
    if (userData) {
      setUser(userData);
      setIsLoggedIn(true);
    }
    return userData;
  };

  return {
    user,
    loading,
    isLoggedIn,
    login: handleLogin,
    logout: handleLogout,
    refreshUser,
  };
}